(function () {
  "use strict";

  var CFG = window.NL_TRACKING || {};
  var PRODUCT = window.NL_PRODUCT || {};
  var drawerOpen = false;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatMoney(cents) {
    var n = Number(cents) / 100;
    return "$" + n.toFixed(2).replace(/\.00$/, ".00");
  }

  function decorateCheckoutUrl() {
    var url = "/checkout";
    try {
      if (window.NLTracking && typeof window.NLTracking.getAttribution === "function") {
        var attr = window.NLTracking.getAttribution();
        var u = new URL(url, window.location.origin);
        ["utm_source", "utm_medium", "utm_campaign", "fbclid", "gclid"].forEach(function (k) {
          if (attr[k] && !u.searchParams.has(k)) u.searchParams.set(k, attr[k]);
        });
        return u.pathname + u.search;
      }
    } catch (e) {}
    return url;
  }

  function trackCheckout(cart) {
    if (!window.NLTracking || !window.NLTracking.track) return;
    var value = cart && cart.total_price ? Number(cart.total_price) / 100 : PRODUCT.price || 19;
    window.NLTracking.track("InitiateCheckout", {
      value: value,
      currency: "USD",
      content_name: (cart && cart.items && cart.items[0] && cart.items[0].product_title) || PRODUCT.title,
    });
    window.NLTracking.track("Lead", { content_category: "cart_drawer" });
  }

  function updateBadges(count) {
    var n = String(count || 0);
    var fab = $("#nl-fab-badge");
    var header = $("#nl-header-cart-badge");
    if (fab) fab.textContent = n;
    if (header) {
      header.textContent = n;
      header.hidden = !count;
    }
  }

  function itemBullets(item) {
    var v = (item.variant_title || "").toLowerCase();
    var sub = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (sub) {
      return [
        "<strong>Month One tonight</strong>, then a new guide each month",
        "All <strong>12 editions</strong> + bonus workbooks included",
        "<strong>Cancel anytime</strong> — manage in your account",
      ];
    }
    if (v.indexOf("full") !== -1 || v.indexOf("pay") !== -1) {
      return [
        "<strong>One payment</strong> — Months 2–12 unlock on schedule",
        "Same guides as monthly, <strong>no recurring bill</strong>",
        "Instant PDF + <strong>printable fridge cards</strong>",
      ];
    }
    return [
      "<strong>76-page</strong> Month One PDF — download tonight",
      "<strong>5 printable</strong> fridge cards & feeding logs",
      "Read on your phone — <strong>nothing to ship</strong>",
    ];
  }

  function discountPct(item) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    if (!original || final >= original) return 0;
    return Math.round((1 - final / original) * 100);
  }

  function renderRefItem(item) {
    var img = item.image ? esc(item.image) : "";
    var pct = discountPct(item);
    var bullets = itemBullets(item)
      .map(function (line) {
        return '<li><span class="nl-drawer-check" aria-hidden="true"></span><span>' + line + "</span></li>";
      })
      .join("");
    var unit = item.quantity > 0 ? formatMoney(item.final_line_price / item.quantity) : formatMoney(item.final_line_price);
    var badge = pct > 0 ? '<span class="nl-drawer-save-badge">-' + pct + "%</span>" : "";
    return (
      '<article class="nl-drawer-line">' +
      '<div class="nl-drawer-line-media">' +
      badge +
      (img
        ? '<img class="nl-drawer-line-img" src="' + img + '" alt="" width="88" height="88" loading="lazy">'
        : '<div class="nl-drawer-line-img nl-drawer-line-img--ph" aria-hidden="true"></div>') +
      "</div>" +
      '<div class="nl-drawer-line-main">' +
      "<h3>" +
      esc(item.product_title) +
      "</h3>" +
      '<p class="nl-drawer-rating"><span class="nl-drawer-stars" aria-hidden="true">★★★★★</span> 4.9 · 40,000+ parents</p>' +
      '<ul class="nl-drawer-bullets">' +
      bullets +
      "</ul>" +
      '<div class="nl-drawer-line-foot">' +
      '<span class="nl-drawer-qty">Qty <strong>' +
      item.quantity +
      "</strong></span>" +
      '<button type="button" class="nl-drawer-remove" data-nl-cart-remove>Remove</button>' +
      '<span class="nl-drawer-unit-price">' +
      unit +
      " each</span>" +
      "</div>" +
      "</div></article>"
    );
  }

  function renderSimpleItem(item) {
    var img = item.image ? esc(item.image) : "";
    return (
      '<article class="nl-drawer-item">' +
      (img
        ? '<img class="nl-drawer-item-img" src="' + img + '" alt="" width="52" height="52" loading="lazy">'
        : '<div class="nl-drawer-item-img nl-drawer-item-img--ph" aria-hidden="true"></div>') +
      '<div class="nl-drawer-item-copy"><h3>' +
      esc(item.product_title) +
      "</h3>" +
      '<p class="nl-drawer-item-price">' +
      formatMoney(item.final_line_price) +
      "</p></div></article>"
    );
  }

  function updateSummary(cart) {
    var totalEl = $("#nl-drawer-total");
    var subEl = $("#nl-drawer-subtotal");
    var saveRow = $("#nl-drawer-savings-row");
    var saveEl = $("#nl-drawer-savings");
    var btnLabel = $("#nl-drawer-checkout-label");
    var note = $("#nl-drawer-plan-note");

    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var discount = Number(cart.total_discount || 0);
    if (!discount) {
      cart.items.forEach(function (item) {
        var o = Number(item.original_line_price || 0) * item.quantity;
        var f = Number(item.final_line_price || 0);
        if (o > f) discount += o - f;
      });
    }

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (subEl) subEl.textContent = formatMoney(subtotal);
    if (saveRow && saveEl) {
      if (discount > 0) {
        saveEl.textContent = "-" + formatMoney(discount).replace("$", "$");
        saveRow.hidden = false;
      } else {
        saveRow.hidden = true;
      }
    }
    if (btnLabel) btnLabel.textContent = "Secure checkout · " + formatMoney(cart.total_price);

    var subLine = "";
    cart.items.forEach(function (item) {
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        subLine = item.selling_plan_allocation.selling_plan.name;
      }
    });
    if (note) {
      if (subLine) {
        note.textContent = "Cancel anytime — manage in your account.";
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  function renderCart(cart) {
    var list = $("#nl-drawer-items");
    var empty = $("#nl-drawer-empty");
    var ref = document.querySelector(".nl-drawer--ref");
    if (!list) return;

    var count = cart.item_count || 0;
    updateBadges(count);

    if (!cart.items || cart.items.length === 0) {
      list.innerHTML = "";
      if (empty) empty.hidden = false;
      updateSummary({ item_count: 0, total_price: 0, items_subtotal_price: 0, items: [] });
      return;
    }

    if (empty) empty.hidden = true;
    list.innerHTML = cart.items
      .map(function (item) {
        return ref ? renderRefItem(item) : renderSimpleItem(item);
      })
      .join("");
    updateSummary(cart);

    list.querySelectorAll("[data-nl-cart-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" })
          .then(function () {
            return fetchCart();
          })
          .then(renderCart)
          .then(closeDrawer);
      });
    });
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (res) {
      return res.json();
    });
  }

  function openDrawer() {
    var overlay = $("#nl-drawer-overlay");
    if (!overlay) return;
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("nl-drawer-open");
    document.body.style.overflow = "hidden";
    drawerOpen = true;
  }

  function closeDrawer() {
    var overlay = $("#nl-drawer-overlay");
    if (!overlay) return;
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("nl-drawer-open");
    document.body.style.overflow = "";
    drawerOpen = false;
  }

  function addItems(items) {
    return fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" })
      .catch(function () {})
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return res.json();
      })
      .then(function () {
        return fetchCart();
      });
  }

  function addSingle(variantId, sellingPlanId) {
    var item = { id: Number(variantId), quantity: 1 };
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);
    return addItems([item]);
  }

  function goCheckout() {
    fetchCart().then(function (cart) {
      trackCheckout(cart);
      window.location.href = decorateCheckoutUrl();
    });
  }

  function renderAndOpen(cart) {
    renderCart(cart);
    openDrawer();
  }

  function onCtaClick(ev) {
    var el = ev.target.closest("a.cta-button, a[href*='/cart/'], .nl-checkout-cta");
    if (!el || el.closest(".nl-yo-cta, #nl-yo-checkout-btn")) return;
    var variantId = CFG.shopifyVariantId || PRODUCT.variantId;
    if (!variantId) return;
    var href = el.getAttribute("href") || "";
    if (href.indexOf("/cart/") === -1 && !el.classList.contains("cta-button") && !el.classList.contains("nl-checkout-cta")) {
      return;
    }

    ev.preventDefault();
    addSingle(variantId, null)
      .then(renderAndOpen)
      .catch(function () {
        window.location.href = "/cart/" + variantId + ":1";
      });
  }

  function bindUi() {
    var overlay = $("#nl-drawer-overlay");
    if (overlay) {
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) closeDrawer();
      });
    }
    var closeBtn = $("#nl-drawer-close");
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

    var checkoutBtn = $("#nl-drawer-checkout");
    if (checkoutBtn) checkoutBtn.addEventListener("click", goCheckout);

    function openFromCart() {
      fetchCart()
        .then(function (cart) {
          if (cart.item_count > 0) renderAndOpen(cart);
          else {
            var vid = CFG.shopifyVariantId || PRODUCT.variantId;
            if (vid) return addSingle(vid, null).then(renderAndOpen);
            openDrawer();
          }
        })
        .catch(openDrawer);
    }

    var fab = $("#nl-fab-cart");
    if (fab) {
      fab.hidden = false;
      fab.addEventListener("click", function () {
        if (drawerOpen) closeDrawer();
        else openFromCart();
      });
    }

    var headerCart = $("#nl-header-cart");
    if (headerCart) {
      headerCart.addEventListener("click", function () {
        if (drawerOpen) closeDrawer();
        else openFromCart();
      });
    }

    document.addEventListener("click", onCtaClick, true);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }

  function boot() {
    bindUi();
    fetchCart().then(renderCart).catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.NLCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    goCheckout: goCheckout,
    render: renderCart,
    renderAndOpen: renderAndOpen,
    addSingle: addSingle,
    fetchCart: fetchCart,
  };
})();
